import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { AddChildDialog, EditChildDialog, RemoveChildDialog, FirstProgramInfoDialog } from './index'
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddIcon from '@material-ui/icons/Add';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import DoneIcon from '@material-ui/icons/Done';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Divider from '@material-ui/core/Divider';
import Euro from '@material-ui/icons/EuroSymbol';
import FavoriteIcon from '@material-ui/icons/Favorite';
import TextField from '@material-ui/core/TextField';
import { Scrollbars } from 'react-custom-scrollbars';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Fab from '@material-ui/core/Fab';
import RootRef from "@material-ui/core/RootRef";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import 'date-fns';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import deepOrange from '@material-ui/core/colors/deepOrange';
import request from 'superagent'
import moment from 'moment';
import * as Constants from '../constants'

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    position: "absolute",
    width: 125,
    right: 60,
    color: theme.palette.text.secondary,
  },
  terciaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    position: "absolute",
    right: 155,
    width: 60,
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

const getItemStyle = draggableStyle => ({
  ...draggableStyle,
  borderRadius: 10,
  margin: 5,
  marginRight: 10
});

class Administration extends React.Component {
  state = {
    expanded: 0,
    snackbar_error_open: false,
    snackbar_message: "",
    loading: false,
    anchorEl: null,
    dialog_add_child_open: false,
    dialog_edit_child_open: false,
    dialog_remove_child_open: false,
    dialog_first_program_info_open: false,
    all_program_data: [],
    program_data: [],
    selected_program_data: [],
    children_data: [],
    selected_child: null,
    driver_enabled: false,
    passengers: 0,
    supervisor: false,
    barbecue_enabled: false,
    barbecue_participants: 0,
    priority_mode: false,
  }

  constructor(props) {
    super(props)

    //Alle Programme laden
    this.loadAllPrograms()
    this.loadChildren();

    //Elternteil wurde hinzugefügt
    if (props.ikey !== undefined) {
      //Kinder hinzufügen
      let currentComponent = this;
      request.post(Constants.BACKEND_URL)
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send({ command: "addparentfinished", parent_id: this.props.userData.id, key: props.ikey })
        .end(function (err, res) {
          var result = res.text.trim();
          if (result === "1") {
            alert("Die Kinder wurden erfolgreich verknüpft!");
            currentComponent.loadChildren();
          } else {
            alert("Beim Verknüpfen der Kinder ist ein Fehler aufgetreten oder der Einladungslink ist abgelaufen!");
          }
        });
    }

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  loadChildren = () => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getchildren", parent_id: this.props.userData.id })
      .end(function (err, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        if (currentComponent.state.selected_child !== null) {
          var new_child = currentComponent.state.selected_child;
          for (const [_, child] of obj.entries()) {
            if (new_child.id === child.id) {
              new_child = child;
              break;
            }
          }
          currentComponent.setState({ children_data: obj, selected_child: new_child });
          currentComponent.onSelectChild(new_child);
        } else {
          currentComponent.setState({ children_data: obj });
        }
      });
  }

  loadAllPrograms = () => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getallprograms" })
      .end(function (_, res) {
        var result = res.text.trim();
        var obj = JSON.parse(result);
        currentComponent.setState({ all_program_data: obj, program_data: obj });
      });
  }

  onSelectChild = child => {
    this.setState({ selected_child: child/*, priority_mode: false*/ });
    this.loadWishlist(child);
  }

  getProgramsForChild = child => {
    //Programme für ausgewähltes Kind filtern
    var program_data = [];
    for (const [_, program] of this.state.all_program_data.entries()) {
      var max_date = new Date(new Date().getFullYear() - program.age_min, 9, 1); // 01.10.
      var min_date = new Date(new Date().getFullYear() - (program.age_max === "0" ? 99 : program.age_max) - 1, 5, 30); // 30.06.
      var dob = moment(child.dob, 'DD.MM.YYYY');
      if (dob > min_date && dob < max_date) program_data.push(program);
    }
    return program_data;
  }

  addChild = (show_dialog) => {
    this.setState({ dialog_add_child_open: show_dialog });
  }

  onChildAdded = () => {
    this.setState({ dialog_add_child_open: false });
    this.loadChildren();
  }

  editChild = (show_dialog) => {
    this.setState({ dialog_edit_child_open: show_dialog });
  }

  onChildEdited = () => {
    this.setState({ dialog_edit_child_open: false });
    this.loadChildren();
  }

  openMenu = (event, child) => {
    this.setState({ anchorEl: event.currentTarget, selected_child: child });
  }

  handleMenuClose = item_id => {
    if (item_id === 0) {
      this.setState({ anchorEl: null });
    } else if (item_id === 1) {
      this.setState({ anchorEl: null, dialog_edit_child_open: true });
    } else if (item_id === 2) {
      this.setState({ anchorEl: null, dialog_remove_child_open: true });
    }
  }

  onChildRemoved = () => {
    this.setState({ dialog_remove_child_open: false, selected_child: null, selected_program_data: [], program_data: this.state.all_program_data });
    this.loadChildren();
  }

  onChildRemoveCanceled = () => {
    this.setState({ dialog_remove_child_open: false });
  }

  onFirstProgramInfoClosed = () => {
    this.setState({ dialog_first_program_info_open: false });
  }

  loadWishlist = child => {
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "getwishlist", child_id: child.id })
      .end(function (_, res) {
        var result = res.text.trim();
        var registrations = JSON.parse(result);
        var selected_program_data = [];
        var new_program_data = [];
        var price = 0;
        for (const [_, program] of currentComponent.getProgramsForChild(child).entries()) {
          var existing = false;
          for (const [_, registration] of registrations.entries()) {
            if (program.id === registration.program_id) {
              program.accepted = registration.accepted;
              program.priority = registration.priority;
              program.passengers = registration.passengers;
              program.supervisor = registration.supervisor;
              program.barbecue_participants = registration.barbecue_participants;
              selected_program_data.push(program);
              price = price + parseFloat(program.price);
              existing = true;
            }
          }
          if (!existing && (currentComponent.props.server_settings.state < 4 || parseInt(program.current_participants) < parseInt(program.participants)))
            new_program_data.push(program);
        }
        for (const [index, other_child] of currentComponent.state.children_data.entries()) {
          if (other_child.id === child.id) {
            currentComponent.state.children_data[index].registrations = selected_program_data.length;
            currentComponent.state.children_data[index].price = price;
            break;
          }
        }
        currentComponent.setState({ selected_program_data: selected_program_data, program_data: new_program_data, loading: false });
      });
  }

  addToWishlist = program_id => {
    this.setState({ loading: true });
    let currentComponent = this;
    if (this.state.selected_program_data.length === 0) this.setState({ dialog_first_program_info_open: true });
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "addtowishlist", child_id: this.state.selected_child.id, program_id: program_id, accepted: (this.props.server_settings.state === 4 ? "E" : "J"), passengers: this.state.passengers, supervisor: this.state.supervisor, barbecue_participants: this.state.barbecue_participants })
      .end(function (_, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.loadWishlist(currentComponent.state.selected_child);
        } else {
          currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true, loading: false });
        }
      });
  }

  removeFromWishlist = program_id => {
    this.setState({ loading: true });
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "removefromwishlist", child_id: this.state.selected_child.id, program_id: program_id })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.loadWishlist(currentComponent.state.selected_child);
          currentComponent.setState({ expanded: 0 });
        } else {
          currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true, loading: false });
        }
      });
  }

  handlePanelChange = panel => (event, expanded) => {
    this.setState({ expanded: expanded ? panel : false, driver_enabled: false, passengers: 0, supervisor: false, barbecue_enabled: false, barbecue_participants: 0 });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbar_open: false, snackbar_success_open: false });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleSwitchChange = name => event => {
    this.setState({ [name]: event.target.checked, ["error_" + name]: false });
  }

  handleDriverEnabled = () => event => {
    this.setState({ driver_enabled: event.target.checked, passengers: event.target.checked ? 1 : 0 });
  }

  handleBarbecueEnabled = () => event => {
    this.setState({ barbecue_enabled: event.target.checked, barbecue_participants: event.target.checked ? 1 : 0 });
  }

  hasTimeOverlap = (program) => {
    const a_start = moment(program.date_from + " " + program.time_from, 'DD.MM.YYYY HH:mm').valueOf();
    const a_end = moment((program.date_to === "" ? program.date_from : program.date_to) + " " + (program.time_to === "" ? program.time_from : program.time_to), 'DD.MM.YYYY HH:mm').valueOf();
    for (const [_, selected_program] of this.state.selected_program_data.entries()) {
      var b_start = moment(selected_program.date_from + " " + selected_program.time_from, 'DD.MM.YYYY HH:mm').valueOf();
      var b_end = moment((selected_program.date_to === "" ? selected_program.date_from : selected_program.date_to) + " " + (selected_program.time_to === "" ? selected_program.time_from : selected_program.time_to), 'DD.MM.YYYY HH:mm').valueOf();

      if (a_start <= b_start && b_start < a_end) return selected_program; // b starts in a
      if (a_start < b_end && b_end <= a_end) return selected_program; // b ends in a
      if (b_start < a_start && a_end < b_end) return selected_program; // a in b
    }
    return false;
  }

  hasState4Registrations = () => {
    for (const [_, program] of this.state.selected_program_data.entries()) {
      if (program.accepted === "E") return true;
    }
    return false;
  }

  getState4RegistrationPrice = () => {
    var total_price = 0;
    for (const [_, program] of this.state.selected_program_data.entries()) {
      if (program.accepted === "E") total_price += parseFloat(program.price);
    }
    return total_price;
  }

  finishRegistration = () => {
    this.setState({ sending_bill: true });
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "finishregistration", parent_id: this.props.userData.id, child_id: this.state.selected_child.id })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "1") {
          currentComponent.setState({ snackbar_message: "Bitte überprüfen Sie Ihr E-Mail Postfach. Evtl. auch den Spam-Ordner.", snackbar_success_open: true, sending_bill: false });
          currentComponent.loadWishlist(currentComponent.state.selected_child);
        } else {
          currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true, sending_bill: false });
        }
      });
  }

  getColorForAccepted = accepted => {
    if (parseInt(this.props.server_settings.state) < 4) return "white";
    if (accepted === "J" || accepted === "C") return green[600];
    if (accepted === "E") return yellow[600];
    if (accepted === "L" || accepted === "D") return red[600];
  }

  getColorForParticipants = (current_participants, participants) => {
    if (current_participants >= participants) return red[600];
    if (current_participants >= participants - 2) return yellow[600];
    return green[600];
  }

  getLabelText = value => {
    return `${value} Herz${value !== 1 ? 'en' : ''}`;
  }

  enterPriorityMode = enabled => {
    this.setState({ priority_mode: enabled });
  }

  comparePriority(a, b) {
    if (Number(a.priority) > Number(b.priority)) return -1;
    if (Number(b.priority) < Number(a.priority)) return 1;
    return 0;
  }

  compareId(a, b) {
    if (Number(a.year_ai) < Number(b.year_ai)) return -1;
    if (Number(b.year_ai) > Number(a.year_ai)) return 1;
    return 0;
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) return;

    var start = result.source.index;
    var end = result.destination.index;

    // Wenn das Item nicht bewegt wurde
    if (start === end) return;

    var list = this.state.selected_program_data.concat().sort(this.comparePriority);

    // Prioritäten anpassen mit 'Nachrutschen'
    var programs = [];
    for (const [index, current_program] of list.entries()) {
      if (start < end) {
        if (index === start) {
          current_program.priority = Number(list[end].priority);
        } else if (index > start && index <= end) {
          current_program.priority = Number(current_program.priority) + 1;
        }
      } else {
        if (index >= end && index < start) {
          current_program.priority = Number(current_program.priority) - 1;
        } else if (index === start) {
          current_program.priority = Number(list[end].priority) + 1;
        }
      }
      programs.push(current_program);
    }

    this.setState({ selected_program_data: programs });

    // Neue Priorität auf den Server übertragen
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .send({ command: "updatepriority", child_id: this.state.selected_child.id, start: start, end: end })
      .end(function (err, res) {
        var result = res.text.trim();
        if (result === "0") currentComponent.setState({ snackbar_message: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut", snackbar_open: true });
      });
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <Fragment>
        {/* Kopfzeile */}
        <div style={{ position: "absolute", width: "100%", height: 26, top: 64, background: deepOrange[400], boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.5)" }}>
          <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(20%)", left: 0 }} inline>{"Kinder"}</Typography>
          {this.props.server_settings.state <= 4 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(40%)", left: "calc(20%)" }} inline>{this.state.selected_child !== null ? "Wunschliste von " + this.state.selected_child.first_name : "Wunschliste"}</Typography>}
          {this.props.server_settings.state <= 4 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(40%)", left: "calc(60%)" }} inline>{this.state.selected_child !== null ? "Programme für " + this.state.selected_child.first_name : "Alle Programme"}</Typography>}
          {this.props.server_settings.state > 4 && <Typography align="center" color="inherit" variant="subtitle1" style={{ position: "absolute", width: "calc(80%)", left: "calc(20%)" }} inline>{this.state.selected_child !== null ? "Anmeldungen von " + this.state.selected_child.first_name : "Anmeldungen"}</Typography>}
        </div>
        {/* Kinder */}
        <div style={{ position: "absolute", width: "20%", height: "calc(100% - 130px)", top: 90, background: "white", opacity: 0.6 }}>
          <div style={{ position: "absolute", top: 0, bottom: 65, left: 0, right: 0 }}>
            <Scrollbars>
              <List>
                {this.state.children_data.map(child => (
                  <ListItem button onClick={() => this.onSelectChild(child)} selected={this.state.selected_child !== null && this.state.selected_child.id === child.id}>
                    <Avatar><AccountCircle /></Avatar>
                    <ListItemText style={{ marginLeft: 15 }} primary={child.first_name + " " + child.last_name + (child.write_access === "0" ? " (Lesezugriff)" : "")} secondary={child.registrations > 0 ? child.registrations + " Anmeldungen •\u00A0Preis:\u00A0" + parseFloat(child.price).toFixed(2).replace(".", ",") + "\u00A0€" : "Keine Anmeldungen"} />
                    {this.props.server_settings !== null && (this.props.server_settings.state < 4 || (this.props.server_settings.state === 4 && child.registrations === 0)) && <Tooltip title="Weitere Optionen" placement="top" enterDelay={500}><IconButton aria-label="Weitere Optionen" aria-haspopup="true" style={{ zIndex: "3" }} onClick={(event) => this.openMenu(event, child)}><MoreVertIcon /></IconButton></Tooltip>}
                  </ListItem>
                ))}
              </List>
            </Scrollbars>
            <Menu anchorEl={this.state.anchorEl} open={this.state.anchorEl !== null} onClose={() => this.handleMenuClose(0)} >
              <MenuItem onClick={() => this.handleMenuClose(1)} disabled={this.state.selected_child !== null && this.state.selected_child.write_access === "0"}>Kind bearbeiten</MenuItem>
              <MenuItem onClick={() => this.handleMenuClose(2)}>{"Kind entfernen"}</MenuItem>
            </Menu>
          </div>
          {/* Leiste */}
          <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 65, background: "grey" }}>
            {this.props.server_settings.state < 5 && <Fab variant="extended" color="secondary" style={{ position: "absolute", bottom: 10, right: 10 }} onClick={() => this.addChild(true)}><AddIcon style={{ marginRight: 10 }} />Kind hinzufügen</Fab>}
          </div>
        </div>
        {/* Wunschliste */}
        {!this.state.priority_mode && <Scrollbars style={{ position: "absolute", left: "20%", width: (this.props.server_settings.state > 4 ? "80%" : "40%"), height: "calc(100% - 200px)", padding: 3, top: 90 }}>
          {this.state.selected_program_data.concat().sort(this.compareId).map(program => (
            <Accordion expanded={this.state.expanded === program.id.toString()} onChange={this.handlePanelChange(program.id.toString())} style={{ borderRadius: 10, margin: 5, marginRight: 10, backgroundColor: this.getColorForAccepted(program.accepted) }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classes.heading} align="left" style={{ marginRight: 160 }}>{program.year_ai + ". " + program.event}</Typography>
                <Typography style={{ position: "absolute", right: 225, color: theme.palette.text.secondary }}>{program.priority}</Typography>
                <FavoriteIcon fontSize="small" color="error" style={{ position: "absolute", right: 200, marginTop: 1 }} />
                <Typography className={classes.secondaryHeading} align="right">{moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'short' }) + ". " + program.date_from.substring(0, 6) + (program.time_from !== "" ? " " + program.time_from : "")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Typography align="left">{"Termin: " + moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'long' }) + " " + program.date_from + (program.date_to !== program.date_from ? " - " + program.date_to : "") + (program.time_from !== "" ? " von " + program.time_from + " bis " + program.time_to : "")}</Typography>
                  <Typography align="left">{"Treffpunkt: " + program.location}</Typography>
                  <Typography align="left">{"Leiter/in: " + program.first_name + " " + program.last_name + ", " + program.department}</Typography>
                  <Typography align="left">Kontakt: <Link color="secondary" href={"mailto:" + program.email}>{program.email}</Link> / <Link color="secondary" href={"tel:" + program.tel}>{program.tel}</Link></Typography>
                  {program.cl_first_name !== "" && this.props.server_settings.state === 5 && (program.accepted === "J" || program.accepted === "C") && <Typography align="left">{"Co-Leiter/in: " + program.cl_first_name + " " + program.cl_last_name}</Typography>}
                  {program.cl_first_name !== "" && this.props.server_settings.state === 5 && (program.accepted === "J" || program.accepted === "C") && <Typography align="left">Kontakt: <Link color="secondary" href={"mailto:" + program.cl_email}>{program.cl_email}</Link> / <Link color="secondary" href={"tel:" + program.cl_tel}>{program.cl_tel}</Link></Typography>}
                  <Typography align="left">{"Kosten: " + (program.price === "0" ? "kostenlos" : parseFloat(program.price).toFixed(2).replace(".", ",") + " €")}</Typography>
                  {(program.age_min !== "0" || program.age_max !== "0") && <Typography align="left">{"Alter: " + (program.age_max === "0" ? "ab " + program.age_min + " Jahren" : program.age_min + " - " + program.age_max + " Jahre")}</Typography>}
                  {program.push_notes !== "" && <Typography align="left">{"Mitzubringen: " + program.push_notes}</Typography>}

                  <Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}>{program.description.split(" ^ ").join("\n").split("^").join("\n")}</Typography>

                  <Divider style={{ marginTop: 10, marginLeft: -20, marginRight: -20 }} />

                  {(program.drivers_needed === "1" || program.supervisors_needed === "1" || program.barbecue === "1") && <Fragment>
                    {/* Anzahl der Passagiere */}
                    {program.drivers_needed === "1" && <div><Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}><b>{program.passengers > 0 ? "Ich kann " + program.passengers + " Kinder mitnehmen" : "Ich fahre nicht"}</b></Typography></div>}
                    {/* Als Betreuer melden */}
                    {program.supervisors_needed === "1" && <div><Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}><b>{program.supervisor === "1" ? "Ich habe mich als Betreuer gemeldet" : "Ich bin kein Betreuer"}</b></Typography></div>}
                    {/* Anzahl der Gäste beim Grillfest */}
                    {program.barbecue === "1" && <div><Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}><b>{program.barbecue_participants > 0 ? "Ich bringe " + program.barbecue_participants + " Personen zur Veranstaltung mit" : "Ich komme nicht zur Veranstaltung"}</b></Typography></div>}
                  </Fragment>}

                  {program.additional_info && <Tooltip title={"Zusätzliche Infos einsehen"} placement="top">
                    <Button variant="outlined" href={"https://formulare-schemmerhofen.de/files/fepro/info_" + program.year_ai + ".pdf"} target="blank" style={{ marginTop: 10, marginRight: 10 }} disabled={this.state.loading} color="primary">Zusätzliche Infos</Button>
                  </Tooltip>}

                  <Tooltip title={this.props.server_settings.state === 5 ? "Keine Abmeldungen mehr möglich" : this.state.selected_child.first_name + " von diesem Programm abmelden"} placement="top">
                    <Button variant="outlined" onClick={() => this.removeFromWishlist(program.id)} style={{ marginTop: 10 }} disabled={this.state.loading || this.state.selected_child.write_access === "0" || this.props.server_settings.state === 5 || (this.props.server_settings.state === 4 && (program.accepted === "J" || program.accepted === "C"))}>
                      {"Von der Wunschliste entfernen"}
                      {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>
                  </Tooltip>
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </Scrollbars>}
        {/* Wunschliste Drag & Drop */}
        {this.state.priority_mode && <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, _) => (
              <RootRef rootRef={provided.innerRef}>
                <Scrollbars style={{ position: "absolute", left: "20%", width: (this.props.server_settings.state > 4 ? "80%" : "40%"), height: "calc(100% - 200px)", padding: 3, top: 90 }}>
                  {this.state.selected_program_data.concat().sort(this.comparePriority).map((program, index) => (
                    <Draggable key={program.id} draggableId={program.id} index={index}>
                      {(provided, _) => (
                        <Accordion
                          ref={provided.innerRef}
                          expanded={this.state.expanded === program.id.toString()}
                          onChange={this.handlePanelChange(program.id.toString())}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(provided.draggableProps.style)}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading} align="left" style={{ marginRight: 160 }}>{program.year_ai + ". " + program.event}</Typography>
                            <Typography style={{ position: "absolute", right: 225, color: theme.palette.text.secondary }}>{program.priority}</Typography>
                            <FavoriteIcon fontSize="small" color="error" style={{ position: "absolute", right: 200, marginTop: 1 }} />
                            <Typography className={classes.secondaryHeading} align="right">{moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'short' }) + ". " + program.date_from.substring(0, 6) + (program.time_from !== "" ? " " + program.time_from : "")}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div>
                              <Typography align="left">{"Termin: " + moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'long' }) + " " + program.date_from + (program.date_to !== program.date_from ? " - " + program.date_to : "") + (program.time_from !== "" ? " von " + program.time_from + " bis " + program.time_to : "")}</Typography>
                              <Typography align="left">{"Treffpunkt: " + program.location}</Typography>
                              <Typography align="left">{"Leiter/in: " + program.first_name + " " + program.last_name + ", " + program.department}</Typography>
                              <Typography align="left">Kontakt: <Link color="secondary" href={"mailto:" + program.email}>{program.email}</Link> / <Link color="secondary" href={"tel:" + program.tel}>{program.tel}</Link></Typography>
                              {program.cl_first_name !== "" && this.props.server_settings.state === 5 && (program.accepted === "J" || program.accepted === "C") && <Typography align="left">{"Co-Leiter/in: " + program.cl_first_name + " " + program.cl_last_name}</Typography>}
                              {program.cl_first_name !== "" && this.props.server_settings.state === 5 && (program.accepted === "J" || program.accepted === "C") && <Typography align="left">Kontakt: <Link color="secondary" href={"mailto:" + program.cl_email}>{program.cl_email}</Link> / <Link color="secondary" href={"tel:" + program.cl_tel}>{program.cl_tel}</Link></Typography>}
                              <Typography align="left">{"Kosten: " + (program.price === "0" ? "kostenlos" : parseFloat(program.price).toFixed(2).replace(".", ",") + " €")}</Typography>
                              {(program.age_min !== "0" || program.age_max !== "0") && <Typography align="left">{"Alter: " + (program.age_max === "0" ? "ab " + program.age_min + " Jahren" : program.age_min + " - " + program.age_max + " Jahre")}</Typography>}
                              {program.push_notes !== "" && <Typography align="left">{"Mitzubringen: " + program.push_notes}</Typography>}

                              <Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}>{program.description.split(" ^ ").join("\n").split("^").join("\n")}</Typography>

                              <Divider style={{ marginTop: 10, marginLeft: -20, marginRight: -20 }} />

                              {(program.drivers_needed === "1" || program.supervisors_needed === "1" || program.barbecue === "1") && <Fragment>
                                {/* Anzahl der Passagiere */}
                                {program.drivers_needed === "1" && <div><Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}><b>{program.passengers > 0 ? "Ich kann " + program.passengers + " Kinder mitnehmen" : "Ich fahre nicht"}</b></Typography></div>}
                                {/* Als Betreuuer melden */}
                                {program.supervisors_needed === "1" && <div><Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}><b>{program.supervisor === "1" ? "Ich habe mich als Betreuuer gemeldet" : "Ich bin kein Betreuer"}</b></Typography></div>}
                                {/* Anzahl der Gäste beim Grillfest */}
                                {program.barbecue === "1" && <div><Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}><b>{program.barbecue_participants > 0 ? "Ich bringe " + program.barbecue_participants + " Personen zur Veranstaltung mit" : "Ich komme nicht zur Veranstaltung"}</b></Typography></div>}
                              </Fragment>}

                              {program.additional_info && <Tooltip title={"Zusätzliche Infos einsehen"} placement="top">
                                <Button variant="outlined" href={"https://formulare-schemmerhofen.de/files/fepro/info_" + program.year_ai + ".pdf"} target="blank" style={{ marginTop: 10, marginRight: 10 }} disabled={this.state.loading} color="primary">Zusätzliche Infos</Button>
                              </Tooltip>}

                              <Tooltip title={this.props.server_settings.state === 5 ? "Keine Abmeldungen mehr möglich" : this.state.selected_child.first_name + " von diesem Programm abmelden"} placement="top">
                                <Button variant="outlined" onClick={() => this.removeFromWishlist(program.id)} style={{ marginTop: 10 }} disabled={this.state.loading || this.state.selected_child.write_access === "0" || this.props.server_settings.state === 5 || (this.props.server_settings.state === 4 && (program.accepted === "J" || program.accepted === "C"))}>
                                  {"Von der Wunschliste entfernen"}
                                  {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                              </Tooltip>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Scrollbars>
              </RootRef>
            )}
          </Droppable>
        </DragDropContext>}
        {this.state.selected_child === null && this.state.children_data.length === 0 && (<Paper style={{ position: 'absolute', left: (this.props.server_settings.state <= 4 ? 'calc(40%)' : 'calc(60%)'), top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Bitte erstellen Sie ein Kind"}</Typography></Paper>)}
        {this.state.selected_child === null && this.state.children_data.length > 0 && (<Paper style={{ position: 'absolute', left: (this.props.server_settings.state <= 4 ? 'calc(40%)' : 'calc(60%)'), top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Bitte wählen Sie ein Kind aus"}</Typography></Paper>)}
        {this.state.selected_child !== null && this.state.selected_program_data.length === 0 && (<Paper style={{ position: 'absolute', left: (this.props.server_settings.state <= 4 ? 'calc(40%)' : 'calc(60%)'), top: '50%', width: '30%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Die Wunschliste von " + this.state.selected_child.first_name + " ist leer. Um Programme hinzuzufügen, wählen Sie diese in der Liste rechts aus und wählen Sie die Option '" + this.state.selected_child.first_name + " anmelden'."}</Typography></Paper>)}
        {/* Leiste unten Priorisierungsänderung */}
        {this.state.selected_child !== null && this.props.server_settings.state === 2 && this.state.selected_child.write_access === "1" && <div style={{ position: "absolute", bottom: 40, left: "20%", right: "40%", height: 65, opacity: 0.6, background: "grey" }}>
          {!this.state.priority_mode && <Fab variant="extended" color="secondary" style={{ position: "absolute", bottom: 10, right: 10 }} onClick={() => this.enterPriorityMode(true)}><FormatListNumberedIcon style={{ marginRight: 10 }} />Priorität ändern</Fab>}
          {this.state.priority_mode && <Fab variant="extended" color="secondary" style={{ position: "absolute", bottom: 10, right: 10 }} onClick={() => this.enterPriorityMode(false)}><DoneIcon style={{ marginRight: 10 }} />Fertig</Fab>}
        </div>}
        {/* Leiste unten Nachmeldung */}
        {this.state.selected_child !== null && this.props.server_settings.state === 4 && this.hasState4Registrations() && <div style={{ position: "absolute", bottom: 40, left: "20%", right: "40%", height: 30, background: "black", opacity: 0.9 }}>
          <span><Fab variant="extended" color="primary" style={{ position: "absolute", left: "50%", transform: 'translate(-50%, -50%)' }} onClick={() => this.finishRegistration()} disabled={this.state.sending_bill}>
            <Euro style={{ marginRight: 10 }} />
            {this.state.selected_child.price > 0 ? "Kostenpflichtig anmelden (" + this.getState4RegistrationPrice().toFixed(2).replace(".", ",") + " €)" : "Anmeldung abschließen"}
            {this.state.sending_bill && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Fab></span>
        </div>}
        {/* Alle Programme */}
        {this.props.server_settings.state <= 4 && <Scrollbars style={{ position: "absolute", right: 0, width: "40%", top: 90, height: "calc(100% - 130px)" }}>
          {this.state.program_data
            .filter(program => (program.event.toLowerCase().includes(this.props.searchString.toLowerCase()) || program.year_ai.toString().includes(this.props.searchString) || program.city.toLowerCase().includes(this.props.searchString.toLowerCase())) && program.date_from.includes(new Date().getFullYear().toString()))
            .filter(program => this.props.server_settings.state <= 3 ? true : parseInt(program.current_participants) < parseInt(program.participants))
            .map(program => (
            <Fragment>
              <Accordion expanded={this.state.expanded === program.id.toString()} onChange={this.handlePanelChange(program.id.toString())} style={{ borderRadius: 7, margin: 5, marginRight: 10 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading} align="left" style={{ marginRight: 155 }}>{program.year_ai + ". " + program.event}</Typography>
                  <Typography className={classes.secondaryHeading} align="right">{moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'short' }) + ". " + program.date_from.substring(0, 6) + (program.time_from !== "" ? " " + program.time_from : "")}</Typography>
                  {this.props.server_settings.state >= 4 && <Typography className={classes.terciaryHeading} align="right" style={{ color: this.getColorForParticipants(parseInt(program.current_participants), parseInt(program.participants)), marginRight: 30 }}>{program.current_participants + " / " + program.participants}</Typography>}
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <Typography align="left">{"Termin: " + moment(program.date_from, "DD.MM.YYYY").toDate().toLocaleDateString('de-DE', { weekday: 'long' }) + " " + program.date_from + (program.date_to !== program.date_from ? " - " + program.date_to : "") + (program.time_from !== "" ? " von " + program.time_from + " bis " + program.time_to : "")}</Typography>
                    <Typography align="left">{"Treffpunkt: " + program.location}</Typography>
                    <Typography align="left">{"Leiter/in: " + program.first_name + " " + program.last_name + ", " + program.department}</Typography>
                    <Typography align="left">Kontakt: <Link href={"mailto:" + program.email}>{program.email}</Link> / <Link href={"tel:" + program.tel}>{program.tel}</Link></Typography>
                    <Typography align="left">{"Kosten: " + (program.price === "0" ? "kostenlos" : parseFloat(program.price).toFixed(2).replace(".", ",") + " €")}</Typography>
                    {(program.age_min !== "0" || program.age_max !== "0") && <Typography align="left">{"Alter: " + (program.age_max === "0" ? "ab " + program.age_min + " Jahren" : program.age_min + " - " + program.age_max + " Jahre")}</Typography>}

                    <Typography align="left" style={{ color: theme.palette.text.secondary, marginTop: 10, whiteSpace: "pre-line" }}>{program.description.split(" ^ ").join("\n").split("^").join("\n")}</Typography>

                    {this.state.selected_child !== null && <Divider style={{ marginTop: 10, marginLeft: -20, marginRight: -20 }} />}

                    {(program.drivers_needed === "1" || program.supervisors_needed === "1" || program.barbecue === "1") && <Fragment style={{ marginTop: 10 }}>
                      {/* Anzahl der Passagiere */}
                      <div>
                        {this.state.selected_child !== null && program.drivers_needed === "1" && <FormControlLabel control={<Switch checked={this.state.driver_enabled} onChange={this.handleDriverEnabled()} disabled={this.state.loading} />} label="Als Fahrer melden - So viele Kinder kann ich mitnehmen:" style={{ marginTop: 3 }} />}
                        {this.state.selected_child !== null && program.drivers_needed === "1" && <TextField defaultValue={1} value={this.state.passengers} type="number" disabled={this.state.loading || !this.state.driver_enabled} onChange={this.handleChange('passengers')} inputProps={{ min: "1", max: "99" }} style={{ width: 50, marginTop: 7 }} />}
                      </div>
                      {/* Als Betreuuer melden */}
                      <div>
                        {this.state.selected_child !== null && program.supervisors_needed === "1" && <FormControlLabel control={<Switch checked={this.state.supervisor} onChange={this.handleSwitchChange('supervisor')} disabled={this.state.loading} />} label="Als Betreuer melden" style={{ marginTop: 3 }} />}
                      </div>
                      {/* Anzahl der Gäste beim Grillfest */}
                      <div>
                        {this.state.selected_child !== null && program.barbecue === "1" && <FormControlLabel control={<Switch checked={this.state.barbecue_enabled} onChange={this.handleBarbecueEnabled()} disabled={this.state.loading} />} label="Ich komme zur Veranstaltung - Gäste:" style={{ marginTop: 3 }} />}
                        {this.state.selected_child !== null && program.barbecue === "1" && <TextField defaultValue={1} value={this.state.barbecue_participants} type="number" disabled={this.state.loading || !this.state.barbecue_enabled} onChange={this.handleChange('barbecue_participants')} inputProps={{ min: "1", max: "99" }} style={{ width: 50, marginTop: 7 }} />}
                      </div>
                    </Fragment>}

                    {this.state.selected_child !== null && <Tooltip title={this.props.server_settings.state === 5 ? "Keine Anmeldungen mehr möglich" : this.state.selected_child.first_name + " zu diesem Programm anmelden"} placement="top">
                      <Button variant="outlined" onClick={() => this.addToWishlist(program.id)} style={{ marginTop: 10 }} disabled={this.state.loading || this.state.selected_child.write_access === "0" || this.props.server_settings.state === 5 || this.hasTimeOverlap(program) !== false} color="primary">
                        {this.state.selected_child.first_name + " anmelden"}
                        {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                      </Button>
                    </Tooltip>}

                    {this.state.selected_child !== null && program.additional_info && <Tooltip title={"Zusätzliche Infos einsehen"} placement="top">
                      <Button variant="outlined" href={"https://formulare-schemmerhofen.de/files/fepro/info_" + program.year_ai + ".pdf"} target="blank" style={{ marginTop: 10, marginLeft: 10 }} disabled={this.state.loading} color="primary">Zusätzliche Infos</Button>
                    </Tooltip>}

                    {this.hasTimeOverlap(program) !== false && <Typography align="left" style={{ color: "red" }}>{"Dieses Programm überschneidet sich mit einem bereits gewählten Programm."}</Typography>}
                  </div>
                </AccordionDetails>
              </Accordion>
            </Fragment>
          ))}
        </Scrollbars>}

        {this.state.selected_child === null && this.state.all_program_data.length === 0 && (<Paper style={{ position: 'absolute', left: 'calc(80%)', top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Keine Programme verfügbar"}</Typography></Paper>)}
        {this.state.selected_child !== null && this.state.program_data.length === 0 && (<Paper style={{ position: 'absolute', left: 'calc(80%)', top: '50%', padding: 10, transform: 'translate(-50%, -50%)' }} elevation={1}><Typography variant="subtitle1">{"Keine weiteren Programme für " + this.state.selected_child.first_name + " verfügbar"}</Typography></Paper>)}
        {/* AddChildDialog */}
        {this.props.userData !== null && <AddChildDialog open={this.state.dialog_add_child_open} onChildAdded={this.onChildAdded} onCancel={() => this.addChild(false)} lastName={this.props.userData.last_name} parentId={this.props.userData.id} />}
        {/* EditChildDialog */}
        {this.props.userData !== null && this.state.selected_child && <EditChildDialog open={this.state.dialog_edit_child_open} onChildEdited={this.onChildEdited} onCancel={() => this.editChild(false)} child={this.state.selected_child} />}
        {/* RemoveChildDialog */}
        {this.props.userData !== null && this.state.selected_child !== null && <RemoveChildDialog open={this.state.dialog_remove_child_open} onChildRemoved={this.onChildRemoved} onCancel={this.onChildRemoveCanceled} child={this.state.selected_child} parentId={this.props.userData.id} />}
        {/* FirstProgramInfoDialog */}
        {this.props.userData !== null && this.state.selected_child !== null && <FirstProgramInfoDialog open={this.state.dialog_first_program_info_open} state={this.props.server_settings.state} onClose={this.onFirstProgramInfoClosed} date={this.props.server_settings.date2} />}

        {/* Success-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_success_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>{this.state.snackbar_message}</span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>
            ]}
            style={{ backgroundColor: green[600] }} />
        </Snackbar>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}><ErrorIcon className={classes.icon} />{this.state.snackbar_message}</span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Fragment>
    );
  }
}

Administration.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  server_settings: PropTypes.object.isRequired,
  ikey: PropTypes.string,
  searchString: PropTypes.string.isRequired,
};

export default withStyles(styles, { withTheme: true })(Administration);
